import * as React from "react";
import { InputNumber } from "primereact/inputnumber";

export const TextNumber = ({ value, handleChange, disabled }) => (
	// TODO: !!!
	// @ts-ignore
	<InputNumber
		onValueChange={(event) => handleChange(event.value)}
		disabled={disabled}
		value={value}
		mode="decimal"
		useGrouping={false}
	/>
);
